/*
 *
 * ReportExport constants
 *
 */

export const GET_MEDITIONS_REPORT_EXPORT_WATCHER =
  "app/ReportExport/GET_MEDITIONS_REPORT_EXPORT_WATCHER"
export const GET_MEDITIONS_REPORT_EXPORT_SUCCESS =
  "app/ReportExport/GET_MEDITIONS_REPORT_EXPORT_SUCCESS"

export const GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER =
  "app/ReportExport/GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_WATCHER"
export const GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_SUCCESS =
  "app/ReportExport/GET_DIVISIONS_AMBASSADOR_REPORT_EXPORT_SUCCESS"

export const GET_EXPORT_REPORT_WATCHER =
  "app/ReportExport/GET_EXPORT_REPORT_WATCHER"
export const GET_EXPORT_REPORT_SUCCESS =
  "app/ReportExport/GET_EXPORT_REPORT_SUCCESS"
export const GET_EXPORT_REPORT_FAILED =
  "app/ReportExport/GET_EXPORT_REPORT_FAILED"
